import React, { useState, useEffect, useRef } from 'react'
import { useMutation } from 'react-query'
import MerckDropdown from '../../shared/merckDropdown/merckDropdown'
import { Button, Col, Divider, InputNumber, Row, Skeleton, Space, Tooltip } from 'antd'
import { message } from 'antd' // Import message from antd
import './CustomerPov.scss'
import TableGrid from '../../shared/TableGrid/TableGrid'
import { useDispatch, useSelector } from 'react-redux'
import {
  updatePotentialSelection,
  updateSelectedAccountDDPOV,
  updateSelectedContractStructureTemplateDDPOV,
  updateTableDataforPotentialMarketCustomerPOV,
  updateTableDataforPotentialMarketResultCustomerPOV,
  updateIsCallPovAPIRefresh,
  updateIsMarketShareSumInvalid,
  updateInitialCustomerPOV,
  updateAccountSummaryDDFetched
} from '../../reducer/customerPov/customerPovSlice'
import {
  setIsScenarioChangesDetectedFlag,
  updateSendContractStructureTemplateIdCustomerPov,
  updateSendContractStructureTemplateIdSummary
} from '../../reducer/CommonSlice'
import { useWindowWidth } from '../../utils/useWindowWidth'
import {
  updateAccountSummaryHeaderAccountDDOptions,
  updateAccountSummaryHeadercontractDDOptions,
  updateSelectedAccountDDACS,
  updateselectedAccountSummaryHeaderAccountDD,
  updateselectedAccountSummaryHeaderContractDD,
  updateselectedContractStructureTemplateACS
} from '../../reducer/accountSummary/accountSummarySlice'

import { getCustomerPOVData, getCustomerPOVPotentialData } from '../../services/customerPOV'

import { ACCOUNTS, CONTRACTTEMPLATE } from '../../constants/accountSummaryConstant'
import { CopyOutlined } from '@ant-design/icons'
import {
  ARIAL_14_PX,
  CURRENT_MARKET_SHARE,
  DELTA,
  DELTA_DOLLAR,
  LABEL,
  MARKET,
  NAC,
  PERCENT_100_WIDTH,
  PERCENT_110_WIDTH,
  PERCENT_125_WIDTH,
  PERCENT_80_WIDTH,
  PERCENT_90_WIDTH,
  POTENTIAL_MARKET_SHARE,
  POTENTIAL_SELECTION,
  PRODUCT_NAME,
  SORT_DIRECTIONS_ASC_DSC
} from '../../constants/customerPov'
import { useGlobalNotification } from '../../utils/notificationProvider'
import { getFilteredValues } from '../../utils/cascadeFilters'

const CustomerPov = () => {
  const dispatch = useDispatch()
  const is_refresh = useSelector((state) => state.Common.is_refresh)
  const selectedWacId = useSelector((state) => state.ContractComparison.selectedWacId)
  const {
    SelectedAccountDDPOV,
    SelectedContractStructureTemplateDDPOV,
    AccountDDPOVOptions,
    ContractStructureTemplateDDPOVOptions,
    tableDataforPotentialMarketCustomerPOV,
    tableDataforPotentialMarketResultCustomerPOV,
    isCallPovAPIRefresh,
    accountSummaryDDFetched

    // potentialSelection
  } = useSelector((state) => state.CustomerPov)

  const [potentialUpdate, setPotentialUpdate] = useState([])
  const [updatedPotentialVerified, setUpdatedPotentialVerified] = useState([])
  const [marketShareSum, setMarketShareSum] = useState({})
  const [filteredSortedData, setFilteredSortedData] = useState([])
  const [filteredDataMapping, setFilteredDataMapping] = useState({})
  // Dummy data for table two

  const {
    isLoading: isCustomerPOVPotentialDataLoading,
    isError: isCustomerPOVPotentialDataFetched,
    data: customerPOVPotentialDataFetched,
    mutateAsync: mutateCustomerPOVPotentialDataFetched
  } = useMutation(getCustomerPOVPotentialData)

  const {
    isLoading: isCustomerPOVDataLoading,
    isError: iscustomerPOVDataFetched,
    data: customerPOVDataFetched,
    mutateAsync: mutateCustomerPOVDataFetched
  } = useMutation(getCustomerPOVData)

  const [marketList, setMarketList] = useState()

  const [isReset, setIsReset] = useState(false)
  const [filter, setFilter] = useState(null)
  const [sorter, setSorter] = useState(null)
  const [currentTableTwoDataSource, setCurrentTableTwoDataSource] = useState(
    tableDataforPotentialMarketResultCustomerPOV
  )
  const [filtersValues, setFiltersValues] = useState({
    market: []
  })
  const selectedAccountDDValue = useSelector(
    (state) => state.AccountSummary.SelectedAccountSummaryHeaderAccountDD
  )

  const selectedContractTemplateDDValue = useSelector(
    (state) => state.AccountSummary.SelectedAccountSummaryHeaderContractDD
  )

  const selectedAccountDDOptions = useSelector(
    (state) => state.AccountSummary.AccountSummaryHeaderAccountDDOptions
  )
  const selectedContractTemplateDDOptions = useSelector(
    (state) => state.AccountSummary.AccountSummaryHeadercontractDDOptions
  )

  const accountDefaultValue = useSelector((state) => state.AccountSummary.accountDefaultValue)

  // const defaultAccount = selectedAccountDDOptions.filter(account =>
  //   accountDefaultValue === account.value
  // );

  const cstDefaultValue = useSelector((state) => state.AccountSummary.cstDefaultValue)

  // const defaultCst = selectedContractTemplateDDOptions.filter(contractStructure =>
  //   cstDefaultValue === contractStructure.value
  // );

  const interimScenarioId = useSelector((state) => state.Common.interim_scenario_id)

  const pushNotification = useGlobalNotification()

  const innerWidth = useWindowWidth()
  function extractDistinctValues(array, property) {
    const distinctValues = []
    const uniqueValues = new Set(array?.map((item) => item[property]))
    uniqueValues.forEach((value) => {
      distinctValues.push({ text: value, value: value })
    })
    return distinctValues
  }

  /* Cascading start */
  const [selectedFilters, setSelectedFilters] = useState({
    market: [],
    product: []
  })
  const [tableKey, setTableKey] = useState(0) // Force re-render
  const tableRef = useRef(null) // Reference to reset filters

  const getFilterOptions = (filterKey) => {
    const filteredvalues = getFilteredValues(
      tableDataforPotentialMarketCustomerPOV,
      selectedFilters,
      filterKey
    )
    return filteredvalues.sort((a, b) => a.text.localeCompare(b.text))
  }

  const handleFilterChange = (filterKey, selectedValues) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey]: selectedValues
    }))
  }
  const handleResetFilters = () => {
    setSelectedFilters({
      market: [],
      product: []
    })
    setTableKey((prevKey) => prevKey + 1) // Force re-render table
    // Reset Ant Design filters manually
    if (tableRef.current) {
      tableRef.current.resetFilters()
    }
    const dataMappings = {}
    tableDataforPotentialMarketCustomerPOV.forEach((data, index) => {
      dataMappings[index] = tableDataforPotentialMarketCustomerPOV.findIndex(
        (findData) => findData.key === data.key
      )
    })
    setFilteredSortedData(tableDataforPotentialMarketCustomerPOV)
    setFilteredDataMapping(dataMappings)
  }

  /* Cascading end */

  useEffect(() => {
    setCurrentTableTwoDataSource(tableDataforPotentialMarketResultCustomerPOV)
  }, [tableDataforPotentialMarketResultCustomerPOV])

  const initialCustomerPOV = useSelector((state) => state.CustomerPov.initialCustomerPOV)
  useEffect(() => {
    if (initialCustomerPOV || !interimScenarioId || !selectedWacId) return
    if (!initialCustomerPOV) {
      dispatch(updateInitialCustomerPOV(true))
    }
    mutateCustomerPOVDataFetched({
      model: {
        filters: [],
        list_details: [],
        settings: {
          interim_scenario_id: interimScenarioId,
          // selectedContractTemplates.contract_structure_template_id,
          account_or_corporate_id:
            Object.keys(selectedAccountDDValue).length === 0
              ? accountDefaultValue?.value
              : selectedAccountDDValue?.value,
          // selectedContractType.contract_type_id,
          ...(sendContractStructureTemplateIdCustomerPov && {
            contract_structure_template_id:
              Object.keys(selectedContractTemplateDDValue).length === 0
                ? cstDefaultValue?.value
                : selectedContractTemplateDDValue?.value
          }),
          wac_type_selected_id: selectedWacId
        }
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
    dispatch(updateSendContractStructureTemplateIdCustomerPov(true))
  }, [interimScenarioId, selectedWacId])
  const { sendContractStructureTemplateIdCustomerPov } = useSelector((state) => state.Common)

  useEffect(() => {
    if (!interimScenarioId || !selectedWacId) return
    if (accountSummaryDDFetched) {
      dispatch(updateAccountSummaryDDFetched(false))
      return
    }
    mutateCustomerPOVDataFetched({
      model: {
        filters: [],
        list_details: [],
        settings: {
          interim_scenario_id: interimScenarioId,
          // selectedContractTemplates.contract_structure_template_id,
          account_or_corporate_id:
            Object.keys(selectedAccountDDValue).length === 0
              ? accountDefaultValue?.value
              : selectedAccountDDValue?.value,
          // selectedContractType.contract_type_id,
          ...(sendContractStructureTemplateIdCustomerPov && {
            contract_structure_template_id:
              Object.keys(selectedContractTemplateDDValue).length === 0
                ? cstDefaultValue?.value
                : selectedContractTemplateDDValue?.value
          }),
          wac_type_selected_id: selectedWacId
        }
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
    dispatch(updateSendContractStructureTemplateIdCustomerPov(true))
    // }
  }, [selectedAccountDDValue, selectedContractTemplateDDValue])

  // for Reset option Update
  useEffect(() => {
    if (isReset || isCallPovAPIRefresh) {
      mutateCustomerPOVDataFetched({
        model: {
          filters: [],
          list_details: [],
          settings: {
            interim_scenario_id: interimScenarioId,
            account_or_corporate_id:
              Object.keys(selectedAccountDDValue).length === 0
                ? accountDefaultValue?.value
                : selectedAccountDDValue?.value,
            ...(sendContractStructureTemplateIdCustomerPov && {
              contract_structure_template_id:
                Object.keys(selectedContractTemplateDDValue).length === 0
                  ? cstDefaultValue?.value
                  : selectedContractTemplateDDValue?.value
            }),
            is_reset: isCallPovAPIRefresh ? false : isReset,
            wac_type_selected_id: selectedWacId
          }
        },
        user_id: sessionStorage.getItem('user_id'),
        application_role: sessionStorage.getItem('application_role')
      })
      dispatch(updateSendContractStructureTemplateIdCustomerPov(true))
      if (isCallPovAPIRefresh) {
        dispatch(updateIsCallPovAPIRefresh(false))
      }
    }
  }, [isReset, isCallPovAPIRefresh])

  useEffect(() => {
    if (updatedPotentialVerified.length > 0) {
      fetchLatestPotentialData(updatedPotentialVerified)
    }
  }, [updatedPotentialVerified])

  const validateMarketShare = (updatedTableData) => {
    const marketShares = updatedTableData.reduce((acc, item) => {
      if (!acc[item.market]) {
        acc[item.market] = 0
      }
      acc[item.market] += parseFloat(item.potential_market_share)

      return acc
    }, {})

    for (const market in marketShares) {
      const roundedValue = Math.round((marketShares[market] + Number.EPSILON) * 100) / 100
      marketShares[market] = roundedValue
    }

    setMarketShareSum(marketShares)

    for (const market in marketShares) {
      const totalShare = marketShares[market]

      if (totalShare < 99.99 || totalShare > 100.01) {
        message.error(`Total potential market share for ${market} is not approximately 100%.`)
        return false
      }

      // updating value based on verification and changes
      dispatch(setIsScenarioChangesDetectedFlag(true))
    }

    return true
  }

  const handleDropdownChange = (record, value) => {
    const updatedRow = JSON.parse(JSON.stringify(tableDataforPotentialMarketCustomerPOV)).map(
      (el) => {
        if (el.product_id === record.product_id) {
          const updatedPS = el.potential_selection.map((ps) => {
            if (ps.product_name === value) {
              ps.is_selected = true
            } else {
              ps.is_selected = false
            }
            return ps
          })
          el.potential_selection = updatedPS
        }
        return el
      }
    )
    dispatch(updateTableDataforPotentialMarketCustomerPOV(updatedRow))
    dispatchUpdateDataSourceCustomerPov(updatedRow, record)
  }

  const fetchLatestPotentialData = (data) => {
    mutateCustomerPOVPotentialDataFetched({
      model: {
        filters: [],
        list_details: [],
        settings: {
          interim_scenario_id: interimScenarioId,
          // selectedContractTemplates.contract_structure_template_id,
          account_or_corporate_id:
            Object.keys(selectedAccountDDValue).length === 0
              ? accountDefaultValue?.value
              : selectedAccountDDValue.value,
          // selectedContractType.contract_type_id,
          contract_structure_template_id:
            Object.keys(selectedContractTemplateDDValue).length === 0
              ? cstDefaultValue?.value
              : selectedContractTemplateDDValue.value,
          potential_market_share: data,
          wac_type_selected_id: selectedWacId
        }
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
  }

  const sortPOVData = (data) => {
    if (!data) return []
    return data.sort((a, b) => {
      const aMarket = a['market']
      const bMarket = b['market']
      const aProduct = a['product_name']
      const bProduct = b['product_name']
      const abMarket = aMarket.localeCompare(bMarket)
      const abProduct = aProduct.localeCompare(bProduct)
      return abMarket == 0 ? abProduct : abMarket
    })
  }

  useEffect(() => {
    dispatch(
      updateTableDataforPotentialMarketCustomerPOV(
        addkey(sortPOVData(customerPOVDataFetched?.data?.result?.market_share_grid))
      )
    )
    setIsReset(false)
    const updatedMetricsGrid = customerPOVDataFetched?.data?.result?.metrics_grid.filter(
      (record) => record.id !== 'ppd_percent' && record.id !== 'ppd_dollar'
    )
    dispatch(updateTableDataforPotentialMarketResultCustomerPOV(updatedMetricsGrid))
  }, [customerPOVDataFetched])

  useEffect(() => {
    const updatedMetricsGrid = customerPOVPotentialDataFetched?.data?.result?.metrics_grid.filter(
      (record) => record.id !== 'ppd_percent' && record.id !== 'ppd_dollar'
    )
    dispatch(updateTableDataforPotentialMarketResultCustomerPOV(updatedMetricsGrid))
  }, [customerPOVPotentialDataFetched])

  const addkey = (data) => {
    let updatedData = data?.map((it) => {
      return { ...it, key: it.product_id }
    })
    return updatedData
  }
  const getTextWidth = (text, font = ARIAL_14_PX) => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    context.font = font
    return context.measureText(text).width + 20
  }

  const getPotentialSelectionWidth = (data) => {
    if (!data) return innerWidth / 10
    let maxText = ''
    data.forEach((datum) => {
      datum[POTENTIAL_SELECTION]?.forEach((row) => {
        if (row[PRODUCT_NAME].length > maxText.length) maxText = row[PRODUCT_NAME]
      })
    })

    const toDivide =
      innerWidth > PERCENT_80_WIDTH
        ? 7
        : innerWidth > PERCENT_90_WIDTH
          ? 8
          : innerWidth > PERCENT_100_WIDTH
            ? 2
            : innerWidth > PERCENT_110_WIDTH
              ? 3
              : innerWidth > PERCENT_125_WIDTH
                ? 5
                : 5
    const columnWidth = Math.min(getTextWidth(maxText), innerWidth / toDivide)
    return columnWidth // width / 5 (here width is the inner width equivalent to 20vw)
  }

  const getColumnMaxWidth = (data, dataIndex) => {
    if (!data) return 20
    const maxText = data.reduce(
      (acc, row) =>
        row[dataIndex] && row[dataIndex].toString().length > acc.length
          ? row[dataIndex].toString()
          : acc,
      ''
    )
    const toDivide =
      innerWidth > PERCENT_80_WIDTH
        ? 12
        : innerWidth > PERCENT_90_WIDTH
          ? 15
          : innerWidth > PERCENT_100_WIDTH
            ? 4
            : innerWidth > PERCENT_110_WIDTH
              ? 4
              : innerWidth > PERCENT_125_WIDTH
                ? 6
                : 8
    return Math.min(getTextWidth(maxText), innerWidth / toDivide) // width / 5 (here width is the inner width equivalent to 20vw)
  }
  let ColumnsConfigONE = [
    {
      title: 'Market',
      dataIndex: MARKET,
      editable: false,
      fixed: 'left',
      align: 'left',
      disabled: false,
      width: getColumnMaxWidth(tableDataforPotentialMarketCustomerPOV, MARKET),
      filters: getFilterOptions(MARKET),
      sorter: (a, b) => {
        const compare = a.market.localeCompare(b.market)
        return compare === 0 ? a.product_name.localeCompare(b.product_name) : compare
      },
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      defaultSortOrder: 'ascend',
      onFilter: (value, record) => record.market === value,
      filterSearch: true,
      render: (text) => {
        return (
          <div
            className="customer-pov-word-wrap"
            style={{
              width: getColumnMaxWidth(tableDataforPotentialMarketCustomerPOV, MARKET)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: 'Product',
      dataIndex: PRODUCT_NAME,
      editable: false,
      disabled: false,
      filters: getFilterOptions(PRODUCT_NAME),
      onFilter: (value, record) => record.product_name === value,
      filterSearch: true,
      width: getColumnMaxWidth(tableDataforPotentialMarketCustomerPOV, PRODUCT_NAME),
      sorter: (a, b) => a.product_name.localeCompare(b.product_name),
      defaultSortOrder: 'ascend',
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (text) => {
        return (
          <div
            className="customer-pov-word-wrap"
            style={{
              width: getColumnMaxWidth(tableDataforPotentialMarketCustomerPOV, PRODUCT_NAME)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: 'NAC($)',
      dataIndex: NAC,
      editable: false,
      // fixed: "right",
      disabled: false,
      // width: "70px",
      align: 'right',
      sorter: (a, b) => a.nac - b.nac,
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (value) => {
        const formattedValue = Number(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        const displayValue =
          formattedValue.length > 13 ? formattedValue.slice(0, 13) + '...' : formattedValue

        return (
          <Tooltip
            title={formattedValue}
            placement="top"
            overlayInnerStyle={{ backgroundColor: 'white', color: 'black', fontWeight: '600' }}
          >
            <div style={{ textAlign: 'right' }}>{displayValue}</div>
          </Tooltip>
        )
      }
    },
    {
      title: 'Current MS(%)',
      dataIndex: CURRENT_MARKET_SHARE,
      editable: false,
      disabled: false,
      // fixed: "right",
      align: 'right',
      // width: "200px",
      sorter: function (a, b) {
        return a.current_market_share - b.current_market_share
      },
      sortDirections: SORT_DIRECTIONS_ASC_DSC
    },
    {
      title: 'Potential',
      dataIndex: POTENTIAL_SELECTION,
      editable: false,
      disabled: false,
      allowNegative: false,
      // fixed: "right",
      align: 'left',
      width: getPotentialSelectionWidth(tableDataforPotentialMarketCustomerPOV),
      sorter: function (a, b) {
        let aproduct = a.potential_selection.find((it) => {
          if (it['is_selected']) {
            return it[PRODUCT_NAME]
          }
        })
        let bproduct = b.potential_selection.find((it) => {
          if (it['is_selected']) {
            return it[PRODUCT_NAME]
          }
        })

        return aproduct?.product_name?.localeCompare(bproduct?.product_name)
      },
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (potentialSelection, record) => {
        const selectedPVal = record?.potential_selection?.filter((el) => el.is_selected)
        const selectedValue = selectedPVal[0].product_name || null

        const updatedPotentialSelection = JSON.parse(JSON.stringify(potentialSelection)).map(
          (el) => {
            el.label = el.product_name
            el.value = el.product_name
            return el
          }
        )
        // return {label: el.product_name, value: el.product_id}});
        return (
          <Space size="middle">
            <MerckDropdown
              options={updatedPotentialSelection}
              placeholder="Select.."
              showSearch={false}
              allowClear={false}
              width={`${getPotentialSelectionWidth(tableDataforPotentialMarketCustomerPOV)}px`}
              value={selectedValue}
              onChange={(val) => handleDropdownChange(record, val)}
              name
              className="dropdown-align-POV-One"
              popupMatchSelectWidth={false}
            ></MerckDropdown>
          </Space>
        )
      }
    },
    {
      title: 'Potential MS(%)',
      dataIndex: POTENTIAL_MARKET_SHARE,
      editable: true,
      disabled: true,
      fixed: 'right',
      align: 'left',
      width: '100px',
      sorter: function (a, b) {
        return a.potential_market_share - b.potential_market_share
      },
      sortDirections: SORT_DIRECTIONS_ASC_DSC
    }
  ]

  let ColumnsConfigTWO = [
    {
      title: '',
      dataIndex: LABEL,
      render: (text) => {
        return text.toUpperCase()
      }
      // width:"40px",
      // fixed:"left",
    },
    {
      title: 'Current',
      dataIndex: CURRENT_MARKET_SHARE,
      editable: false,
      disabled: false,
      align: 'right',
      // width:"100px",
      sorter: (a, b) => a.current_market_share.localeCompare(b.current_market_share),
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (value) => {
        const displayValue = value.length > 15 ? value.slice(0, 15) + '...' : value

        return (
          <Tooltip
            title={value}
            placement="top"
            overlayInnerStyle={{ backgroundColor: 'white', color: 'black', fontWeight: '600' }}
          >
            <div style={{ textAlign: 'right' }}>{displayValue}</div>
          </Tooltip>
        )
      }
    },
    {
      title: 'Potential',
      dataIndex: POTENTIAL_MARKET_SHARE,
      editable: false,
      disabled: false,
      align: 'right',
      // width:"100px",
      sorter: (a, b) => a.potential_market_share.localeCompare(b.potential_market_share),
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (value) => {
        const displayValue = value.length > 15 ? value.slice(0, 15) + '...' : value

        return (
          <Tooltip
            title={value}
            placement="top"
            overlayInnerStyle={{ backgroundColor: 'white', color: 'black', fontWeight: '600' }}
          >
            <div style={{ textAlign: 'right' }}>{displayValue}</div>
          </Tooltip>
        )
      }
    },

    {
      title: 'Delta Dollar',
      dataIndex: DELTA_DOLLAR,
      editable: false,
      disabled: false,
      align: 'right',
      // width:"100px",
      sorter: (a, b) => {
        const anum = parseFloat(a.delta_dollar.split('$')[1])
        const bnum = parseFloat(b.delta_dollar.split('$')[1])
        return anum - bnum
      },
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (delta_dollar) => {
        const numericValue = parseFloat(delta_dollar.replace(/[^0-9.-]+/g, ''))

        let color = numericValue > 0 ? 'green' : numericValue < 0 ? 'red' : 'black'

        return <span style={{ color }}>{delta_dollar}</span>
      }
    },

    {
      title: 'Delta',
      dataIndex: DELTA,
      editable: false,
      disabled: false,
      width: '60px',
      align: 'right',
      // fixed:"right",
      sorter: (a, b) => {
        const anum = parseFloat(a.delta.split('%')[0])
        const bnum = parseFloat(b.delta.split('%')[0])
        return anum - bnum
      },
      sortDirections: SORT_DIRECTIONS_ASC_DSC,
      render: (delta) => {
        const numericValue = parseFloat(delta.replace(/[^0-9.-]+/g, ''))
        let color = numericValue > 0 ? 'green' : numericValue < 0 ? 'red' : 'balck'
        return <span style={{ color }}>{delta}</span>
      }
    }
  ]

  const dispatchUpdateDataSourceCustomerPov = (currentData) => {
    const potentialUpdateData = currentData.map((el) => {
      return {
        product_id: el.product_id,
        potential_percent: parseFloat(parseFloat(el.potential_market_share).toFixed(2)),
        potential_product_id: el.potential_selection.filter((el) => el.is_selected)[0].product_id
      }
    })
    setPotentialUpdate(potentialUpdateData)
    if (validateMarketShare(currentData)) {
      setUpdatedPotentialVerified(potentialUpdateData)
    }
    dispatch(updateTableDataforPotentialMarketCustomerPOV(currentData))
  }

  const handleReset = () => {
    setIsReset(true)
    setSelectedFilters({
      market: [],
      product: []
    })
    const dataMappings = {}
    tableDataforPotentialMarketCustomerPOV.forEach((data, index) => {
      dataMappings[index] = tableDataforPotentialMarketCustomerPOV.findIndex(
        (findData) => findData.key === data.key
      )
    })
    setFilteredSortedData(tableDataforPotentialMarketCustomerPOV)
    setFilteredDataMapping(dataMappings)
    dispatch(setIsScenarioChangesDetectedFlag(true))
  }

  const handleDropDownValueChange = (e, value, type) => {
    let valueData = { value: value.value, label: value.label }
    if (e) {
      switch (type) {
        case ACCOUNTS:
          dispatch(updateSendContractStructureTemplateIdCustomerPov(false))
          dispatch(updateSendContractStructureTemplateIdSummary(false))
          dispatch(updateselectedAccountSummaryHeaderAccountDD(valueData))
          break

        case CONTRACTTEMPLATE:
          dispatch(updateselectedAccountSummaryHeaderContractDD(valueData))
          break
      }
    }
  }

  const handleCopySuccess = () => {
    pushNotification(
      'success',
      'Data copied successfully!',
      'Customer POV data copied successfully.',
      3
    )
  }

  const handleCopyError = () => {
    pushNotification('error', 'Copy failed', 'Error copying the data.', 3)
  }

  const onCopyCustomerPOV = () => {
    // Copy headers
    let columnHeader = ColumnsConfigTWO.map((col) => col.title).join('\t')

    // Copy data
    let DataToColumn = currentTableTwoDataSource
      .map((item) => {
        return [
          // item.id,
          item.label.toUpperCase(),
          item.current_market_share,
          item.potential_market_share,
          item.delta_dollar,
          item.delta
        ].join('\t')
      })
      .join('\n')

    // Combine headers and  Column data for Copy
    const dataToCopy = `${columnHeader}\n${DataToColumn}`

    // Write the formatted data to the clipboard
    navigator.clipboard
      .writeText(dataToCopy)
      .then(() => {
        console.log('Data copied to clipboard successfully!')
        handleCopySuccess()
      })
      .catch((error) => {
        console.error('Error copying data to clipboard:', error)
        handleCopyError()
      })
  }

  const handleTableChange = (pagination, filters, sorter, extra) => {
    handleFilterChange(PRODUCT_NAME, filters[PRODUCT_NAME] || [])
    handleFilterChange(MARKET, filters[MARKET] || [])
    const filteredData = extra.currentDataSource
    const dataMappings = {}
    filteredData.forEach((data, index) => {
      dataMappings[index] = tableDataforPotentialMarketCustomerPOV.findIndex(
        (findData) => findData.key === data.key
      )
    })
    setFilteredSortedData(extra.currentDataSource)
    setFilteredDataMapping(dataMappings)
  }
  useEffect(() => {
    const tableData = tableDataforPotentialMarketCustomerPOV
    if (!tableData || !tableData.length) return
    const sortedData = JSON.parse(JSON.stringify(tableData)).sort((a, b) => {
      const marketComp = a.market.localeCompare(b.market)
      const productComp = a.product_name.localeCompare(b.product_name)
      return marketComp === 0 ? productComp : marketComp
    })
    const dataMappings = {}
    sortedData.forEach((data, index) => {
      dataMappings[index] = tableDataforPotentialMarketCustomerPOV.findIndex(
        (findData) => findData.key === data.key
      )
    })
    setFilteredSortedData(sortedData)
    setFilteredDataMapping(dataMappings)
  }, [tableDataforPotentialMarketCustomerPOV])

  const onCopyCustomerPOVGrid = () => {
    let data = filteredSortedData
    if (!filteredSortedData.length) {
      setFilteredSortedData(tableDataforPotentialMarketCustomerPOV)
      data = [...tableDataforPotentialMarketCustomerPOV]
    }
    // Ensure only displayed data is copied
    let columnHeader = ColumnsConfigONE.map((col) => col.title).join('\t')
    let DataToColumn = data
      .map((item) => {
        return [
          item.market,
          item.product_name,
          item.nac,
          item.current_market_share,
          item.potential_selection.filter((e) => e.is_selected)?.[0]?.product_name || '',
          item.potential_market_share
        ].join('\t')
      })
      .join('\n')

    // Combine headers and filtered/sorted data for copy
    const dataToCopy = `${columnHeader}\n${DataToColumn}`

    navigator.clipboard
      .writeText(dataToCopy)
      .then(() => {
        console.log('Filtered & Sorted Data Copied Successfully!')
        handleCopySuccess()
      })
      .catch((error) => {
        console.error('Error copying data:', error)
        handleCopyError()
      })
  }
  useEffect(() => {
    const isMarketShareSumInvalid = Object.keys(marketShareSum)
      .map((key) => {
        const mss = marketShareSum[key]
        return mss < 99.99 || mss > 100.01
      })
      .includes(true)
    dispatch(updateIsMarketShareSumInvalid(isMarketShareSumInvalid))
  }, [marketShareSum])

  return (
    <div className="customerPOV-main-container">
      <Skeleton active loading={isCustomerPOVDataLoading} paragraph={{ rows: 8 }}>
        <div className="customer-POV-Header-One">
          <Col>
            <div style={{ display: 'flex', gap: '12px' }}>
              <div className="dropdownContainers-POV">
                <span className="dropdown-text-POV">Account</span>
                <MerckDropdown
                  options={JSON.parse(JSON.stringify(selectedAccountDDOptions)).sort((a, b) => {
                    const sorted = a.label.localeCompare(b.label)
                    return sorted
                  })}
                  placeholder="Select Account"
                  showSearch={true}
                  allowClear={false}
                  disabled={is_refresh === 'Y' || is_refresh === 'D'}
                  value={selectedAccountDDValue.label}
                  defaultValue={accountDefaultValue?.label || 'Loading...'}
                  onChange={(e, value) => {
                    handleDropDownValueChange(e, value, ACCOUNTS)
                  }}
                  name="account"
                  className="dropdown-align-POV account-summary-dropdown"
                />
              </div>
              <div className="dropdownContainers-POV">
                <span className="dropdown-text-POV">Contract Structure Template</span>
                <MerckDropdown
                  options={JSON.parse(JSON.stringify(selectedContractTemplateDDOptions)).sort(
                    (a, b) => {
                      const sorted = a.label.localeCompare(b.label)
                      return sorted
                    }
                  )}
                  placeholder="Select Template"
                  showSearch={true}
                  allowClear={false}
                  disabled={is_refresh === 'Y' || is_refresh === 'D'}
                  defaultValue={cstDefaultValue?.label || 'Loading...'}
                  value={selectedContractTemplateDDValue?.label}
                  onChange={(e, value) => {
                    handleDropDownValueChange(e, value, CONTRACTTEMPLATE)
                  }}
                  name="contractStructureTemplate"
                  className="dropdown-align-POV account-summary-dropdown"
                />
              </div>
            </div>
          </Col>
        </div>
        <div>
          <div
            style={{
              background: 'white',
              padding: ' 0px 16px 16px 16px',
              margin: '16px',
              border: '1px solid #E1E9EF'
              // height:"1000px"
            }}
          >
            <div
              className="main-tables"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center'
              }}
            >
              <Col
                flex={3}
                className="container_table_column_alignment"
                style={{
                  paddingBottom: '50px'
                  // width: "60%",
                }}
              >
                <div
                  className="table-heading"
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <div>
                    <span className="dropdown-text-POV-2">Customer POV</span>
                    <p className="dropdown-text-bottom-POV-2">
                      Manually adjust Product selections to test impact on deltas
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                      className="button-customerpov button-reset-filters"
                      onClick={handleResetFilters}
                      disabled={Object.keys(selectedFilters).every(
                        (key) => selectedFilters[key]?.length === 0
                      )}
                    >
                      Reset Filters
                    </Button>
                    <Button onClick={onCopyCustomerPOVGrid} className="button-icon-align">
                      <CopyOutlined />
                    </Button>
                  </div>
                </div>
                <TableGrid
                  scroll1={{
                    y: 350,
                    x: 'max-content'
                  }}
                  columnsConfig={ColumnsConfigONE}
                  dataSource={tableDataforPotentialMarketCustomerPOV}
                  dispatchUpdateDataSource={dispatchUpdateDataSourceCustomerPov}
                  //   disptachTableParam={disptachTableParam}
                  // onChange={(pagination, filters, sorter) => {
                  // dispatch(setFilter(filters));
                  // dispatch(setSorter(sorter));
                  // }}
                  onChange={handleTableChange} // Track table changes
                  filteredDataMapping={filteredDataMapping} // Pass this prop for Index Based Pasting for filtered and sorted data
                  filteredData={filteredSortedData}
                  setFilteredData={setFilteredSortedData}
                  pagination={false}
                  handleNegative={true}
                  key={tableKey} // Ensures table refresh
                  ref={tableRef} // Reference to reset filters
                  // tableLayout="fixed"
                  // style={{ minWidth: "129px" }}
                  className="custom-scroll-table"
                />
              </Col>

              <Col
                flex={1}
                className="container_table_column_alignment_one"
                style={
                  {
                    // width: "100%",
                  }
                }
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <div
                    className="table-heading"
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginBottom: '38px',
                      marginTop: '38px',
                      gap: '8px'
                    }}
                  >
                    <Button onClick={onCopyCustomerPOV} className="button-icon-align">
                      <CopyOutlined />
                    </Button>
                    <Button className="button-customerpov" onClick={handleReset}>
                      Reset To Default
                    </Button>
                  </div>
                  <Skeleton
                    active
                    loading={isCustomerPOVPotentialDataLoading}
                    paragraph={{ rows: 8 }}
                  >
                    <TableGrid
                      columnsConfig={ColumnsConfigTWO}
                      dataSource={tableDataforPotentialMarketResultCustomerPOV}
                      pagination={false}
                      onChange={(pagination, filters, sorter, extra) => {
                        setCurrentTableTwoDataSource(extra.currentDataSource)
                        // dispatch(setFilter(filters));
                        // dispatch(setSorter(sorter));
                      }}
                      scroll1={{
                        // y: 350,
                        x: true
                      }}
                    />
                  </Skeleton>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </Skeleton>
    </div>
  )
}

export default CustomerPov
